<!-- Copyright 2025 Midas Healthcare Solutions - All Rights Reserved -->
<ng-container *transloco="let t">
  <div class="ui-dialog-top-bar">
    <span class="header">
      <mat-icon color="primary">notification_important</mat-icon>
      <span>{{ t('Info') }}</span>
    </span>
  </div>

  <div style="padding: 0 16px">
    {{ t('VideoOverlayHelpText') }}

    <div class="dialog-button-wrapper">
      <mat-checkbox
          [style.margin-right]="'1rem'"
          [checked]="doNotShowAgain"
          (change)="doNotShowAgainChanged()"
        >
          {{ t('DoNotShowAgain') }}
        </mat-checkbox>

      <button mat-flat-button color="primary" utilProcessing (click)="continue()">
        {{ t('OK') }}
      </button>
    </div>
  </div>
</ng-container>
